import { combineReducers } from "redux";

import signInReducer from "./SignIn/SignIn.Reducer";

const rootReducer = combineReducers({
  SignIn: signInReducer
});

export default rootReducer;
